import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { getSurveyResult3 } from "../../../api/surveyQuestion.api";
import useAxios from "../../../hooks/useAxios";
import { getCommonCodeLabel } from "../../../lib/store";
import { IGetSurveyResult3 } from "../../../models/surveyQuestion.model";
import Button from "../../Button";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import SurveyResult3DetailModal from "./modals/SurveyResult3DetailModal";

interface IProps {
  surveyCode: number|undefined;
}

const SurveyResult3: FC<IProps> = ({
  surveyCode,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSurveyResult3>();

  const [questionCode, setQuestionCode] = useState<number>();
  const [surveyResult3DetailVisible, setSurveyResult3DetailVisible] = useState(false);

  useEffect(() => {
    if (surveyCode) {
      execute(getSurveyResult3(surveyCode));
    }
  }, [surveyCode]);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="comm-table__area">
        <table>
          <thead>
            <tr>
              <th className="text-center">{t('common.column.category')}</th>
              <th className="text-center">{t('common.column.title')}</th>
              <th className="text-center">{t('common.button.detail')}</th>
            </tr>
          </thead>
          <tbody>
            
            {res?.data?.map((item, index) => (
              <tr key={index}>
                <td className="text-center">{getCommonCodeLabel('HP0007', item.surveyCategory, 'ko')}{item.surveyCategory}</td>
                <td className="text-center">{item.title}</td>
                <td className="text-center">
                  <div className="comm-btn__area justify-content-center">
                    <Button
                      className="btn-basic mint"
                      onClick={() => {
                        setQuestionCode(item.questionCode);
                        setSurveyResult3DetailVisible(true);
                      }}
                      text={t('common.button.detail')}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {surveyResult3DetailVisible &&
        <SurveyResult3DetailModal
          visible={surveyResult3DetailVisible}
          setVisible={setSurveyResult3DetailVisible}
          surveyCode={surveyCode}
          questionCode={questionCode}
        />
      }
    </>
  );
}

export default SurveyResult3;
